import Vue from 'vue';
import axios from './vue-axios/axios'

export function statsOffersCurrentWeek(params) {
  return Vue.axios.get(`${process.env.API_URL}/v1/dashboard_manager/offers_stats_current_week`, { params: params })
}

export function getUsers(params) {
  return Vue.axios.get(`${process.env.API_URL}/v1/dashboard_manager/users`, {params: params})
}

export function offersPublished(params){
  return Vue.axios.get(`${process.env.API_URL}/v1/dashboard_manager/offers_published`, { params: params })
}

export function offersWaiting(params){
  return Vue.axios.get(`${process.env.API_URL}/v1/dashboard_manager/offers_waiting`, { params: params })
}



// WEBPACK FOOTER //
// ./src/backend/dashboard.js